import React, { ChangeEvent } from 'react';

import { Field } from 'formik';

import Text from '@components/common/Text/Text';

import css from './Radio.module.scss';

type RadioContentProps = {
    customClass?: string;
    containerClass?: string;
    inputName: string;
    inputValue: string;
    label: string;
    desc?: string;
    onRadioChange?: (inputValue) => void;
    field: {
        name: string;
        value: string;
        onChange: (e: ChangeEvent) => void;
    };
};

const RadioContent = ({
    field: { name, value, onChange },
    label,
    onRadioChange,
    containerClass,
    customClass,
    inputValue,
    desc,
}: RadioContentProps) => {
    return (
        <div className={containerClass || ''}>
            <label className={`${css.radio__wrapper} ${customClass || ''}`}>
                <input
                    name={name}
                    type="radio"
                    value={inputValue}
                    checked={inputValue === value}
                    onChange={(e) => {
                        onChange(e);
                        onRadioChange && onRadioChange(inputValue);
                    }}
                    className={css.radio}
                />
                <div className={`${css.radio__styled} ${inputValue === value && css.radio__styled__checked} `} />
                <Text variant={'caption_01'} color={'txt-primary'}>
                    {label}
                </Text>
            </label>
            <Text variant={'body_02'} color={'txt-secondary'}>
                {desc}
            </Text>
        </div>
    );
};

type RadioProps = {
    customClass?: string;
    containerClass?: string;
    inputName: string;
    inputValue: any;
    label: string;
    desc?: string;
    onChange: (value: any) => void;
};

const Radio = ({ inputName, customClass, containerClass, onChange, inputValue, label, desc }: RadioProps) => {
    return (
        <Field
            component={RadioContent}
            name={inputName}
            customClass={customClass}
            containerClass={containerClass}
            onRadioChange={(value) => onChange(value)}
            inputValue={inputValue}
            label={label}
            desc={desc}
        />
    );
};

export default Radio;
